/**
 * Portal-side record of the editor history.
 *
 * The builder's own undo stack still lives in ReportBuilderView, because every
 * edit already passes through that one apply/amend/retract path and the stack
 * is a list of whole documents. This slice mirrors those steps into the portal
 * store so a session can see them and so the history is not only a ref inside
 * one component. It does not write to Timescale; the autosave POST does that.
 */
import {createSlice} from '@reduxjs/toolkit';

const HISTORY = 60;

const reportBuilderSlice = createSlice({
  name: 'reportBuilder',
  initialState: {
    reportId: '',
    past: [],
    present: null,
    future: [],
    saveState: 'idle',
  },
  reducers: {
    historyApplied(state, action) {
      if (state.present) state.past = [...state.past, state.present].slice(-HISTORY);
      state.present = action.payload;
      state.future = [];
      state.reportId = action.payload && action.payload.id || state.reportId;
      state.saveState = 'dirty';
    },
    historyStepped(state, action) {
      const back = action.payload === 'back';
      const from = back ? state.past : state.future;
      const to = back ? state.future : state.past;
      if (!from.length || !state.present) return;
      to.push(state.present);
      state.present = from.pop();
      state.saveState = 'dirty';
    },
    historyLanded(state, action) {
      state.past = [];
      state.future = [];
      state.present = action.payload;
      state.saveState = 'saved';
    },
    saveStateSet(state, action) {
      state.saveState = action.payload;
    },
  },
});

export const {historyApplied, historyStepped, historyLanded, saveStateSet} = reportBuilderSlice.actions;
export default reportBuilderSlice.reducer;
